import { CircularProgress } from '@material-ui/core'
import React from 'react'

const Spinner = props => <div><CircularProgress/></div>

export default Spinner 